import { useState } from 'react';

import { CommentPreview } from '@gogame/components';

import { EditCommentForm } from '../CommentForm';
import { TEXT, ID } from '../CommentForm/constants';

export const DATA_CY = 'comment';

const Comment = ({
  id,
  mark,
  author = '',
  date = '',
  message = '',
  onComment,
  onDelete,
  withActions,
  autoFocus,
  onLoadSuggestions,
}) => {
  const [editing, setEditing] = useState(false);

  const handleSubmit = async (values) => {
    await onComment(values);
    setEditing(false);
  };
  const handleCancel = () => {
    setEditing(false);
  };

  if (editing) {
    return (
      <EditCommentForm
        onLoadSuggestions={onLoadSuggestions}
        initialValues={{
          [ID]: id,
          [TEXT]: message,
        }}
        autoFocus={autoFocus}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    );
  }

  return (
    <CommentPreview
      dataCy={DATA_CY}
      mark={mark}
      author={author}
      date={date}
      message={message}
      withActions={withActions}
      onEdit={() => setEditing(true)}
      onDelete={onDelete}
    />
  );
};
export default Comment;
